// extracted by mini-css-extract-plugin
export default {"three":"SecThree_three__enIjj","main":"SecThree_main__H5JQy","up":"SecThree_up__r-Xsv","down":"SecThree_down__UFhvl"};